import { render, staticRenderFns } from "./starSchedule.vue?vue&type=template&id=8c004902&scoped=true"
import script from "./starSchedule.vue?vue&type=script&lang=js"
export * from "./starSchedule.vue?vue&type=script&lang=js"
import style0 from "./starSchedule.vue?vue&type=style&index=0&id=8c004902&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c004902",
  null
  
)

export default component.exports